import React from 'react';
import { PlacedWord } from '../types';
import './UnfoundWords.css';

interface UnfoundWordsProps {
  allWords: PlacedWord[];
  foundWords: string[];
}

// Must match colors in Cell.tsx
const UNFOUND_COLORS = [
  '#8B0000', // Dark red
  '#006400', // Dark green
  '#00008B', // Dark blue
  '#8B008B', // Dark magenta
  '#FF8C00', // Dark orange
  '#2F4F4F', // Dark slate gray
  '#4B0082', // Indigo
  '#800000', // Maroon
  '#008080', // Teal dark
  '#9932CC', // Dark orchid
];

const UnfoundWords: React.FC<UnfoundWordsProps> = ({ allWords, foundWords }) => {
  const unfoundWords = allWords.filter(w => !foundWords.includes(w.word));

  if (unfoundWords.length === 0) return null;

  return (
    <div className="unfound-words-container">
      <h3 className="unfound-words-title">
        😔 Words You Missed ({unfoundWords.length})
      </h3>
      <div className="unfound-words-list">
        {unfoundWords.map((placedWord, index) => (
          <div 
            key={placedWord.word} 
            className="unfound-word-item"
            style={{ backgroundColor: UNFOUND_COLORS[index % UNFOUND_COLORS.length] }}
          >
            <span className="unfound-word-text">{placedWord.word}</span>
            <span className="unfound-word-hint">
              ({placedWord.word.length} letters)
            </span>
          </div>
        ))}
      </div>
      <p className="unfound-words-tip">
        💡 Numbers on cells show letter order (1 = first letter)
      </p>
    </div>
  );
};

export default UnfoundWords;
